import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { FR } from "./fr";

const LanguageContext = createContext(null);
const STORAGE_KEY = "np_lang";

function initialLang() {
  const saved = typeof window !== "undefined" && localStorage.getItem(STORAGE_KEY);
  if (saved === "en" || saved === "fr") return saved;
  // French-first default for our Quebec / Montreal audience
  return "fr";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(initialLang);

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, lang); } catch { /* ignore */ }
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => setLangState(l === "en" ? "en" : "fr"), []);
  const toggle = useCallback(() => setLangState((p) => (p === "fr" ? "en" : "fr")), []);

  // Translate by English source string. Returns FR when active, else the original.
  const t = useCallback((text) => {
    if (lang === "en" || text == null) return text;
    return FR[text] ?? text;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) return { lang: "en", setLang: () => {}, toggle: () => {}, t: (x) => x };
  return ctx;
}
